<template>
	<div class="nav1" :class="{ 'nav1--fixed': isFixedNav }">
		<div class="nav1">
			<nav class="nav">
				<div class="container nav__inner">
					<div
						v-for="(item, index) in navList"
						:key="item + activeName"
						class="nav__item-wrap"
						:class="{
							active: isActiveTop(item),
							'is-open': openDropdown === item,
						}"
						@mouseenter="onItemEnter(item, $event)"
						@mouseleave="onItemLeave"
					>
						<!-- 「报告」nav 项 -->
						<a
							v-if="item === '报告'"
							class="nav__item"
							:href="'/baogao?attr=' + item"
						>
							<img
								class="nav__icon"
								:src="getNavIcon(item)"
								alt=""
							/>
							<span class="nav__text">{{ item }}</span>
						</a>

						<!-- 「数据」nav 项（无 href，纯展示） -->
						<span
							v-else-if="item === '数据'"
							class="nav__item nav__item--pure"
						>
							<img
								class="nav__icon"
								:src="getNavIcon(item)"
								alt=""
							/>
							<span class="nav__text">{{ item }}</span>
						</span>

						<!-- 普通 nav 项 -->
						<a
							v-else
							class="nav__item"
							:href="
								item == '首页' ? '/' : '/baogao?attr=' + item
							"
						>
							<img
								class="nav__icon"
								:src="getNavIcon(item)"
								alt=""
							/>
							<span class="nav__text">{{ item }}</span>
						</a>
					</div>
					<div class="nav__date">
						{{ yearMonthDayAndWeek.year }}-{{
							padZero(yearMonthDayAndWeek.month)
						}}-{{ padZero(yearMonthDayAndWeek.day) }}
						{{ yearMonthDayAndWeek.week }}
					</div>
				</div>
			</nav>

			<nav v-if="isShowSubNav" class="subnav">
				<div class="container subnav__inner">
					<div class="subnavGroup subnavGroup--left">
						<a
							v-for="item in leftSubNavList"
							:key="item.uid"
							:href="'/hylist?uid=' + item.uid"
							:class="{ active: isActiveLeft(item) }"
							@click="activeSubNav = item"
						>
							{{ item.text }}
						</a>
					</div>

					<div class="subnavGroup subnavGroup--right">
						<a
							class="activeSubNav"
							style="color: #ffc869; font-weight: 700"
						>
							重点专题：
						</a>
						<a
							v-for="item in rightSubNavList"
							:key="item.uid"
							:href="'/specialTopic?uid=' + item.uid"
							:class="{ active: isActiveRight(item) }"
							@click="activeSubNav = item"
						>
							{{ item.text }}
						</a>
					</div>
				</div>
			</nav>
		</div>

		<!--
			下拉菜单：从 nav 里完全拆出去，传送（Teleport）到 body 下。
			这样跟整个 layout / subnav / appMain 没有任何 DOM 父子关系，
			z-index 在根堆叠上下文直接生效，从物理上消除了"和后面同层"的可能性。
			注意：teleport 必须放在 template 单根元素内部（Vue2 限制），
			但内容仍然会渲染到 body 下，跟这里的位置无关。
		-->
		<teleport to="body">
			<div
				v-if="openDropdown === '报告'"
				class="nav-dropdown nav-dropdown--teleport"
				:style="dropdownFixedStyle"
				@mouseenter="onDropdownEnter"
				@mouseleave="onDropdownLeave"
			>
				<a
					href="javascript:;"
					class="nav-dropdown__group"
					@click.prevent="onReport('all')"
					>国研系列研究报告</a
				>
				<a
					href="javascript:;"
					class="nav-dropdown__item"
					@click.prevent="onReport('yiyao')"
					>医药行业报告</a
				>
				<a
					href="javascript:;"
					class="nav-dropdown__item"
					@click.prevent="onReport('swcy')"
					>生物产业报告</a
				>
				<a
					href="javascript:;"
					class="nav-dropdown__item"
					@click.prevent="onReport('jkcy')"
					>健康产业报告</a
				>
				<a
					href="javascript:;"
					class="nav-dropdown__group"
					@click.prevent="onReport('other')"
					>其他机构研究报告</a
				>
			</div>

			<div
				v-if="openDropdown === '数据'"
				class="nav-dropdown nav-dropdown--teleport"
				:style="dropdownFixedStyle"
				@mouseenter="onDropdownEnter"
				@mouseleave="onDropdownLeave"
			>
				<!-- <a
					href="javascript:;"
					class="nav-dropdown__group"
					@click.prevent="onStat('all')"
					>统计数据</a
				> -->
				<a
					href="javascript:;"
					class="nav-dropdown__item"
					@click.prevent="onStat('yiyao')"
					>医药行业</a
				>
				<a
					href="javascript:;"
					class="nav-dropdown__item"
					@click.prevent="onStat('weisheng')"
					>卫生行业</a
				>
				<a
					href="javascript:;"
					class="nav-dropdown__item"
					@click.prevent="onStat('shijie')"
					>世界卫生</a
				>
			</div>
		</teleport>
	</div>
</template>

<script>
import { getNav } from '../../api/home';
export default {
	name: 'MedicalHome',
	data() {
		return {
			keyword: '',
			searchType: '全文检索',
			searchTypes: ['全文检索', '标题检索', '作者检索'],
			navList: ['首页', '政策', '数据', '报告', '案例', '论文', '资讯'],
			leftSubNavList: [],
			rightSubNavList: [],
			activeName: '',
			activeSubNav: null,
			yearMonthDayAndWeek: '',
			// 当前展开下拉的 nav 项名
			openDropdown: '',
			// 下拉菜单位置（position: fixed 用 viewport 坐标）
			dropdownTop: 0,
			dropdownLeft: 0,
			// 关闭宽限期定时器：鼠标从 nav 移到下拉的瞬间，延迟 200ms 再判断要不要关
			closeTimer: null,
			// 二级页吸顶：hylist / baogao / specialTopic
			// 首页（home）保持原样，跟着 banner 走
			isFixedNav: false,
			// subnav 是否显示：baogao（hotContent）路由下不显示副导航
			isShowSubNav: true,
		};
	},
	watch: {
		MobileVerification: {
			handler(to) {
				// console.log(to);
				this.isMoblie = this.MobileVerification;
				// this.isMobileVt();
				// this.isMobileValue();
			},
			immediate: true,
		},
		$route: {
			handler(to) {
				this.activeName = to.name;
				console.log('to.name', to.name);
				// 二级页吸顶：首页不固定
				this.isFixedNav =
					to.name === 'hylist' ||
					to.name === 'hotContent' ||
					to.name === 'specialTopic';
				// subnav 显示控制：baogao（hotContent）不显示
				this.isShowSubNav = to.name !== 'hotContent';

				this.syncSubNavByRoute(to);
			},
		},
	},
	mounted() {
		this.yearMonthDayAndWeek = this.getYearMonthDayAndWeek();
		this.activeName = this.$route.name;
		// 初始化吸顶状态（避免首次渲染时类名未生效）
		this.isFixedNav =
			this.$route.name === 'hylist' ||
			this.$route.name === 'hotContent' ||
			this.$route.name === 'specialTopic';
		this.isShowSubNav = this.$route.name !== 'hotContent';
		this.syncSubNavByRoute(this.$route);
		this.getNavs();
	},
	beforeDestroy() {
		// 清理可能未触发的关闭定时器
		if (this.closeTimer) {
			clearTimeout(this.closeTimer);
			this.closeTimer = null;
		}
	},
	methods: {
		//获取年月日和星期
		getYearMonthDayAndWeek() {
			const date = new Date();
			const year = date.getFullYear();
			const month = date.getMonth() + 1;
			const day = date.getDate();
			const week = date.getDay();
			const weekArray = [
				'周日',
				'周一',
				'周二',
				'周三',
				'周四',
				'周五',
				'周六',
			];
			return { year, month, day, week: weekArray[week] };
		},
		// 数字补 0（1 → "01"）
		padZero(n) {
			return n < 10 ? '0' + n : '' + n;
		},
		// 顶部导航每个分类的图标 PNG（顺序与 navList 对应）
		getNavIcon(name) {
			const map = {
				首页: require('../../assets/homeImage/navIcon/home.png'),
				资讯: require('../../assets/homeImage/navIcon/news.png'),
				论文: require('../../assets/homeImage/navIcon/paper.png'),
				报告: require('../../assets/homeImage/navIcon/report.png'),
				案例: require('../../assets/homeImage/navIcon/case.png'),
				政策: require('../../assets/homeImage/navIcon/policy.png'),
				数据: require('../../assets/homeImage/navIcon/data.png'),
			};
			return map[name] || '';
		},
		getNavs() {
			// const data = getNav({ version: 'A2' });
			getNav({ version: '96' }).then((res) => {
				console.log(res);
				for (let index = 0; index < res.data.data.length; index++) {
					const element = res.data.data[index];
					// console.log(element);
					if (element.isnav && element.uid != '9611') {
						this.leftSubNavList.push(element);
					}
				}

				// localStorage.removeItem('leftNavList');
				// localStorage.setItem(
				// 	'leftNavList',
				// 	JSON.stringify(res.data.data)
				// );
				for (let index = 0; index < res.data.data.length; index++) {
					const element = res.data.data[index];
					// console.log(element);
					if (element.uid == '9611') {
						this.rightSubNavList = element.children;
					}
				}
				// 列表加载完后，根据当前 route 同步一次高亮
				this.syncSubNavByRoute(this.$route);
			});
		},
		switchTab(sectionKey, tab) {
			this.$set(this.activeTabs, sectionKey, tab);
		},
		// 顶部一级导航：判断某个 item 是否处于激活态
		isActiveTop(name) {
			// console.log('activeName', name);
			// console.log('activeName', this.activeName);
			if (!this.activeName) return false;
			if (name === '首页' && this.activeName === 'home') return true;
			if (name === '专题' && this.activeName === 'specialTopic')
				return true;
			// 其余 navList 跳的是 /baogao?attr=xxx，route name 是 baogao
			if (
				this.activeName === 'hotContent' ||
				this.activeName === 'hylist' ||
				this.activeName === 'hotContent'
			) {
				return this.$route.query.attr === name;
			}
			return false;
		},
		// 左侧二级导航（/hylist?uid=xxx）：通过 query.uid 匹配
		isActiveLeft(item) {
			return (
				this.$route.name === 'hylist' &&
				this.$route.query.uid === item.uid
			);
		},
		// 右侧专题（/specialTopic?uid=xxx）：通过 query.uid 匹配
		isActiveRight(item) {
			return (
				this.$route.name === 'specialTopic' &&
				this.$route.query.uid === item.uid
			);
		},
		// 根据当前 route 自动同步 activeSubNav（用于点击导航后刷新仍高亮）
		syncSubNavByRoute(to) {
			const name = to.name;
			const uid = to.query && to.query.uid;
			if (name === 'hylist' && uid) {
				const hit = this.leftSubNavList.find((i) => i.uid === uid);
				if (hit) this.activeSubNav = hit;
			} else if (name === 'specialTopic' && uid) {
				const hit = this.rightSubNavList.find((i) => i.uid === uid);
				if (hit) this.activeSubNav = hit;
			}
		},
		// 报告下拉跳转：all/other 走站内 baogao；yiyao/swcy/jkcy 走 report.drcnet.com.cn 新页
		// id/idname 来自 homeContent/index.vue:339-354 的 reportCards 配置
		onReport(type) {
			const industryMap = {
				yiyao: { id: '900503', idname: '医药行业' },
				swcy: { id: '900707', idname: '生物产业' },
				jkcy: { id: '900708', idname: '健康产业' },
			};
			if (industryMap[type]) {
				const c = industryMap[type];
				window.open(
					`https://report.drcnet.com.cn/#/allReports?id=${
						c.id
					}&idname=${encodeURIComponent(c.idname)}`,
					'_blank',
				);
				return;
			}
			const queryMap = {
				all: '/baogao?attr=报告',
				other: '/baogao?attr=报告&filter=other',
			};
			const target = queryMap[type];
			if (!target) return;
			this.$router.push(target).catch((err) => {
				if (err && err.name !== 'NavigationDuplicated') {
					console.error(err);
				}
			});
		},
		// 数据下拉跳转：all 跳 data 主页；其余按 subjectId 跳指标库（对应首页 leftBanner__button）
		onStat(type) {
			if (type === 'all') {
				window.open('https://data.drcnet.com.cn/', '_blank');
				return;
			}
			const statMap = {
				yiyao: 'S48', // 医药行业
				weisheng: 'S65', // 卫生行业
				shijie: 'S36', // 世界卫生
			};
			const subjectId = statMap[type];
			if (!subjectId) return;
			window.open(
				`https://data.drcnet.com.cn/indicator?columnId=null&subjectId=${subjectId}`,
				'_blank',
			);
		},
		// 鼠标进入 nav 项：用 wrap 的 getBoundingClientRect() 算出下拉该出现的位置
		onItemEnter(item, e) {
			if (this.closeTimer) {
				clearTimeout(this.closeTimer);
				this.closeTimer = null;
			}
			const rect = e.currentTarget.getBoundingClientRect();
			this.dropdownTop = rect.bottom + 10;
			this.dropdownLeft = rect.left + rect.width / 2;
			this.openDropdown = item;
		},
		// 鼠标离开 nav 项：延迟 200ms 关闭，给"鼠标移到下拉"留宽限期
		onItemLeave() {
			if (this.closeTimer) clearTimeout(this.closeTimer);
			this.closeTimer = setTimeout(() => {
				this.openDropdown = '';
				this.closeTimer = null;
			}, 200);
		},
		// 鼠标进入下拉本身：清掉关闭定时器
		onDropdownEnter() {
			if (this.closeTimer) {
				clearTimeout(this.closeTimer);
				this.closeTimer = null;
			}
		},
		// 鼠标离开下拉：立即关闭
		onDropdownLeave() {
			if (this.closeTimer) clearTimeout(this.closeTimer);
			this.openDropdown = '';
		},
	},
	computed: {
		// teleport + position: fixed：用 viewport 坐标定位，绕开一切父级堆叠上下文
		dropdownFixedStyle() {
			return {
				position: 'fixed',
				top: this.dropdownTop + 'px',
				left: this.dropdownLeft + 'px',
				transform: 'translateX(-50%)',
			};
		},
	},
};
</script>

<style scoped lang="less">
.nav1 {
	width: 100%;
	min-width: 1400px;
	// height: 84px;
	display: flex;
	// line-height: 84px;
	background: #015293 url('../../assets/homeImage/navbj.jpg') repeat-x;
	flex-direction: column;
	// 必须有 position，z-index 才会生效；不写的话 2000 直接被浏览器忽略
	position: relative;
	z-index: 2000;
}

/* 二级页：滚动到 nav1 时吸顶在视口顶部
   sticky 不脱离文档流，比 fixed 更稳；首页不挂这个类，保持原样 */
.nav1--fixed {
	position: sticky;
	top: 0;
	z-index: 2000;
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.medical-page {
	color: #1d3557;
	background: #f3f7fb;
	min-height: 100vh;
}

.container {
	width: 1400px;
	margin: 0 auto;
}

.hero {
	position: relative;
	overflow: hidden;
	color: #fff;
	background: linear-gradient(
			90deg,
			rgba(17, 93, 167, 0.95),
			rgba(95, 172, 238, 0.78)
		),
		url('https://images.unsplash.com/photo-1579154204601-01588f351e67?auto=format&fit=crop&w=1600&q=80')
			center/cover no-repeat;
	padding-bottom: 14px;
}

.hero::before {
	content: '';
	position: absolute;
	inset: 0;
	background: radial-gradient(
			circle at 22% 18%,
			rgba(255, 255, 255, 0.42),
			transparent 30%
		),
		radial-gradient(
			circle at 78% 28%,
			rgba(255, 255, 255, 0.18),
			transparent 24%
		);
	pointer-events: none;
}

.hero__topbar,
.hero__main,
.nav__inner,
.subnav__inner {
	position: relative;
	z-index: 1;
	width: 1400px;
	margin: 0 auto;
}

.hero__topbar {
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding-top: 8px;
	font-size: 12px;
	opacity: 0.96;
}

.hero__links {
	display: flex;
	align-items: center;
	gap: 10px;
}

.hero__links a {
	color: #fff;
	text-decoration: none;
}

.hero__main {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	padding-top: 26px;
	padding-bottom: 12px;
	gap: 16px;
}

.hero__brand {
	width: 100%;
	text-align: center;
}

.hero__subtitle {
	font-size: 14px;
	letter-spacing: 2px;
	opacity: 0.78;
}

.hero__title {
	margin-top: 4px;
	font-size: 38px;
	font-weight: 800;
	line-height: 1.1;
	text-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
}

.hero__search {
	width: 100%;
	display: flex;
	justify-content: center;
}

.searchBox {
	display: flex;
	align-items: center;
	gap: 6px;
	padding: 8px;
	background: rgba(255, 255, 255, 0.97);
	border-radius: 8px;
	box-shadow: 0 8px 22px rgba(10, 36, 72, 0.14);
}

.searchBox__select,
.searchBox__input {
	height: 34px;
	border: 1px solid #d7e1ec;
	border-radius: 4px;
	padding: 0 10px;
	font-size: 13px;
	outline: none;
}

.searchBox__input {
	width: 260px;
}

.searchBtn {
	height: 34px;
	border: 0;
	border-radius: 4px;
	padding: 0 12px;
	color: #fff;
	cursor: pointer;
	font-size: 13px;
}

.searchBtn--blue {
	background: #1677ff;
}

.searchBtn--cyan {
	background: #23a4df;
}

.searchBtn--orange {
	background: #f2a41a;
}

.nav {
	background: #307cc9;
	box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.16);
}
::v-deep .nav1 {
	line-height: 45px;
}
.nav__inner {
	height: 55px;
	display: flex;
	align-items: center;
	justify-content: flex-start;
	gap: 70px;
	position: relative;
}

/* 顶栏单项外层容器（含下拉菜单的定位锚） */
.nav__item-wrap {
	position: relative;
	display: inline-flex;
	align-items: center;
}

/* hover / active 时在 nav 项正下方显示橙色下划线指示器 */
.nav__item-wrap::after {
	content: '';
	position: absolute;
	bottom: -6px;
	left: 50%;
	transform: translateX(-50%);
	width: 67px;
	height: 3px;
	background: #ffc180;
	border-radius: 2px;
	opacity: 0;
	transition: opacity 0.18s ease;
	pointer-events: none;
}
.nav__item-wrap:hover::after,
.nav__item-wrap.active::after {
	opacity: 1;
}

.nav__item {
	display: inline-flex;
	align-items: center;
	color: #fff;
	text-decoration: none;
	font-size: 20px;
}

/* active / hover 时文字变黄（原选择器改为 wrap 级） */
.nav__item-wrap.active .nav__text {
	// color: #ffd85c;
	font-weight: 700;
}

.nav__icon {
	width: 18px;
	height: 18px;
	margin-right: 8px;
	vertical-align: center;
	display: inline-block;
}

.nav__sep {
	margin: 0 50px;
	font-size: 17px;
	color: rgba(255, 255, 255, 0.72);
}

.nav__date {
	position: absolute;
	right: 0;
	top: 50%;
	transform: translateY(-50%);
	font-size: 17px;
	color: rgba(255, 255, 255, 0.9);
}

/* ====== 下拉菜单样式（teleport 版：通过 <teleport to="body"> 渲染到 body 下） ====== */
.nav-dropdown {
	min-width: 220px;
	padding: 8px 0;
	margin: 0;
	border-radius: 5px;
	background: #00407c;
	box-shadow: 0px 1px 15px 0px rgba(135, 137, 139, 0.48);
	opacity: 0.93;
	// 在 body 根级别：z-index 直接生效，绝对盖住任何 stacking context 内的内容
	z-index: 9999;
	list-style: none;
}

.nav-dropdown__group,
.nav-dropdown__item {
	display: block;
	padding: 12px 24px;
	margin: 0 8px;
	border-radius: 4px;
	color: #fff;
	font-size: 15px;
	font-weight: 700;
	text-align: center;
	text-decoration: none;
	white-space: nowrap;
	line-height: 1.2;
	font-family: SourceHanSerifCN-Heavy, 'PingFang SC', 'Microsoft YaHei',
		sans-serif;
	transition: background 0.15s ease, color 0.15s ease;
	box-sizing: border-box;
}

.nav-dropdown__group {
	background: transparent;
}

.nav-dropdown__item {
	background: transparent;
	font-weight: 500;
}

.nav-dropdown__divider {
	display: block;
	height: 0;
	margin: 6px 20px;
	border-top: 1px dashed rgba(255, 255, 255, 0.3);
	list-style: none;
}

.nav-dropdown__group:hover,
.nav-dropdown__item:hover {
	background: rgba(255, 255, 255, 0.12);
	color: #ffd85c;
}

.subnav {
	background: #0e569a;
}

.subnav__inner {
	height: 49px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 20px;
	overflow: hidden;
}

.subnavGroup {
	display: flex;
	align-items: center;
	gap: 68px;
	white-space: nowrap;
}

.subnavGroup--right {
	margin-left: auto;
	gap: 34px;
}

.subnavTitle {
	font-size: 17px;
	color: #ffd85c;
	font-weight: 700;
}

.subnav a {
	font-size: 17px;
	color: rgba(255, 255, 255, 0.92);
	text-decoration: none;
	white-space: nowrap;
}

.subnav a.active {
	color: #ffd85c;
	font-weight: 700;
}

.splitBlock {
	display: grid;
	grid-template-columns: 300px 1fr;
	gap: 18px;
	margin-top: 18px;
}

.leftBanner,
.leftCard,
.rightPanel,
.sectionBlock,
.specialSection {
	background: #fff;
	border: 1px solid #e5edf6;
	border-radius: 10px;
	box-shadow: 0 1px 8px rgba(25, 61, 104, 0.04);
}

.leftBanner {
	min-height: 92px;
	padding: 16px;
	margin-bottom: 12px;
	display: flex;
	flex-direction: column;
	justify-content: flex-end;
	color: #fff;
}

.leftBanner--primary {
	background: linear-gradient(135deg, #4a8fdd, #73c4ff);
}

.leftBanner--secondary {
	background: linear-gradient(135deg, #2f6db9, #3ca2f1);
}

.leftBanner__title {
	font-size: 20px;
	font-weight: 700;
}

.leftBanner__desc {
	margin-top: 6px;
	font-size: 13px;
	line-height: 1.6;
	opacity: 0.96;
}

.leftCard {
	padding: 16px;
}

.leftCard__head {
	color: #174b7a;
	font-size: 18px;
	font-weight: 700;
	padding-bottom: 10px;
	margin-bottom: 12px;
	border-bottom: 1px solid #e8edf4;
}

.leftCard__pills {
	margin-top: 12px;
	display: flex;
	flex-wrap: wrap;
	gap: 8px;
}

.leftCard__pills span {
	padding: 5px 10px;
	border-radius: 999px;
	background: #f1f5f9;
	color: #607086;
	font-size: 13px;
}

.rightPanel {
	padding-bottom: 8px;
}

.sectionHeader {
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 10px 14px;
	border-bottom: 1px solid #e8edf4;
}

.sectionHeader__title {
	display: flex;
	align-items: flex-end;
	gap: 6px;
}

.sectionHeader__title h2 {
	margin: 0;
	font-size: 21px;
	line-height: 1;
	display: inline-flex;
	align-items: baseline;
}

.sectionHeader__title .titleBlue {
	color: #1460b1;
}

.sectionHeader__title .titleBlack {
	color: #1d3557;
}

.sectionHeader__title i {
	width: 62px;
	height: 2px;
	background: #2d7eea;
	display: block;
	margin-bottom: 4px;
}

.sectionHeader a {
	color: #b0b8c3;
	font-size: 12px;
	text-decoration: none;
}

.recommendList {
	padding: 0 14px 8px;
}

.recommendItem {
	display: flex;
	justify-content: space-between;
	gap: 14px;
	padding: 14px 0;
	border-bottom: 1px solid #eef2f7;
}

.recommendItem__body {
	flex: 1;
	min-width: 0;
}

.recommendItem__title {
	font-size: 16px;
	font-weight: 700;
	margin-bottom: 8px;
}

.recommendItem__summary {
	color: #708090;
	font-size: 13px;
	line-height: 1.7;
}

.recommendItem__link {
	margin-top: 6px;
	color: #d44f3a;
	font-size: 12px;
	font-weight: 600;
}

.recommendItem__date {
	white-space: nowrap;
	color: #95a3b3;
	font-size: 13px;
}

.sectionBlock {
	margin-top: 22px;
	padding: 12px;
}

.specialSection {
	margin-top: 22px;
	padding: 12px;
}

.specialList {
	padding: 0 14px;
}

.specialItem {
	display: grid;
	grid-template-columns: 160px 1fr auto;
	gap: 14px;
	align-items: center;
	padding: 14px 0;
	border-bottom: 1px solid #eef2f7;
}

.specialItem:last-child {
	border-bottom: 0;
}

.specialItem img {
	width: 160px;
	height: 92px;
	border-radius: 8px;
	object-fit: cover;
}

.specialItem__title {
	font-weight: 700;
	margin-bottom: 6px;
}

.specialItem__summary {
	color: #6f7f90;
	font-size: 13px;
	line-height: 1.7;
}

.specialItem button {
	border: 1px solid #c8d6e6;
	background: #fff;
	color: #4f6b8a;
	border-radius: 4px;
	padding: 7px 14px;
}

.footer {
	margin-top: 28px;
	background: #0d6fb8;
	color: #fff;
	padding: 18px 0 16px;
}

.footer__inner {
	flex-direction: column;
	gap: 10px;
}

.footer__nav {
	background: #0d6fb8;
	display: flex;
	align-items: center;
	gap: 12px;
	justify-content: center;
	flex-wrap: wrap;
	font-size: 13px;
}

.footer__nav a {
	color: #fff;
	text-decoration: none;
}

.footer__brand {
	font-size: 12px;
	opacity: 0.88;
	text-align: center;
}

@media (max-width: 769px) {
	.container {
		width: calc(100% - 30px);
	}

	.hero__topbar,
	.hero__main {
		flex-direction: column;
		align-items: flex-start;
		gap: 12px;
	}

	.nav__inner,
	.subnav__inner {
		width: calc(100% - 30px);
		height: auto;
		padding: 10px 0;
		flex-wrap: wrap;
		justify-content: flex-start;
	}

	.nav__date {
		position: static;
		transform: none;
		margin-left: auto;
	}

	.splitBlock {
		grid-template-columns: 1fr;
	}

	.specialItem {
		grid-template-columns: 1fr;
	}
}
</style>
